import { Container } from "inversify";
import { GeometryService, DefaultGeometryService } from "../uis/ui-services/geometry-ui-service";
import TYPES from "./types";
import { UIMapService, DefaultUIMapService } from "../uis/ui-services/ui-map-service";
import { CameraService, DefaultCameraService } from "../uis/ui-services/camera-service";
import { DefaultGameStateService, GameStateService } from "../services/game-state-service";
import { DefaultSocketIOService } from "../services/socketio-service";
import { DefaultEventService, EventService } from "../services/event-service";
import {
    KeyboardMappingService,
    DefaultKeyboardMappingService,
} from "../services/keyboardmapping-service";
import { AuthService, DefaultAuthService } from "../services/auth-service";
import { ThemeManager, DefaultThemeManager } from "../uis/design-system/theme-manager";
import { AuthenticatedAssetLoader } from "../services/authenticated-asset-loader";
import { SaveGameService } from "../services/save-game-service";
import { MessageQueueService, IMessageQueueService } from "../services/message-queue-service";

const container = new Container();

// unsorted yet
container
    .bind<DefaultSocketIOService>(TYPES.SocketIOService)
    .to(DefaultSocketIOService)
    .inSingletonScope();
container
    .bind<GameStateService>(TYPES.GameStateService)
    .to(DefaultGameStateService)
    .inSingletonScope();
container
    .bind<KeyboardMappingService>(TYPES.KeyboardMappingService)
    .to(DefaultKeyboardMappingService)
    .inSingletonScope();
container.bind<EventService>(TYPES.EventService).to(DefaultEventService).inSingletonScope();
container.bind<AuthService>(TYPES.AuthService).to(DefaultAuthService).inSingletonScope();
container
    .bind<AuthenticatedAssetLoader>(TYPES.AuthenticatedAssetLoader)
    .to(AuthenticatedAssetLoader)
    .inSingletonScope();
container.bind<SaveGameService>(TYPES.SaveGameService).to(SaveGameService).inSingletonScope();
container
    .bind<IMessageQueueService>(TYPES.MessageQueueService)
    .to(MessageQueueService)
    .inSingletonScope();

// UI
container.bind<UIMapService>(TYPES.UIMapService).to(DefaultUIMapService).inSingletonScope();
container.bind<CameraService>(TYPES.CameraService).to(DefaultCameraService).inSingletonScope();
container
    .bind<GeometryService>(TYPES.GeometryService)
    .to(DefaultGeometryService)
    .inSingletonScope();
container.bind<ThemeManager>(TYPES.ThemeManager).to(DefaultThemeManager).inSingletonScope();

export default container;
